








import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import merge from 'lodash/merge';

@Component({
    name: 'widget-content-settings'
})
export default class ContentSettings extends Vue
{
    @Prop() private value!: any;

    private defaults: any = {
        content: ''
    };

    protected get form(): any
    {
        return this.value;
    }

    async created()
    {
        this.form.settings = merge(this.defaults, this.form.settings);
    }

    @Watch('form.settings', {deep: true})
    onSettingsChanged(value: any)
    {
        this.$emit('input', this.form);
    }
}
